<nb-card class="dialog">
  <nb-card-header>
    <h4>{{ "pages.creator.trash.title" | translate }}</h4>
  </nb-card-header>
  <nb-card-body>
    <p class="intro">{{ "pages.creator.trash.description" | translate }}</p>
    <app-orbi-loader *ngIf="rows === null" [size]="80"></app-orbi-loader>
    <p *ngIf="rows && rows.length === 0" class="empty">{{ "pages.creator.trash.empty" | translate }}</p>
    <ul *ngIf="rows && rows.length > 0" class="al-list trash-list">
      <li *ngFor="let row of rows">
        <div class="trash-row">
          <span class="trash-row__copy">
            <span class="trash-row__title">{{ row.title }}</span>
            <span class="trash-row__meta">{{ row.kindLabel }} · {{ "pages.creator.trash.deleted" | translate: { when: row.deletedText } }}</span>
          </span>
          <button
            nbButton
            appearance="outline"
            status="primary"
            size="small"
            type="button"
            [nbSpinner]="restoring === row.id"
            [disabled]="restoring !== null"
            (click)="restore(row)"
          >
            {{ "pages.creator.trash.restore" | translate }}
          </button>
        </div>
      </li>
    </ul>
  </nb-card-body>
  <nb-card-footer>
    <button type="button" nbButton status="primary" (click)="close()">{{ "buttons.close" | translate }}</button>
  </nb-card-footer>
</nb-card>
